import {
  DASHBOARD,
  TEMPLATES,
  REPORTS,
  TIME_WISE_GRAPH_REPORTS,
  DAY_GRAPH_REPORT,
  TIME_WISE_SUMMARY_REPORTS,
  COMPANY_SETTINGS,
  DAY_SUMMARY_REPORT,
  SHIFT_SETTING,
  OPERATOR_SUMMARY_REPORT,
  OPERATOR_DETAIL_REPORT,
  PART_SUMMARY_REPORT,
  PART_DETAIL_REPORT,
  PERFORMANCE_REPORT,
  PART_SETTING,
  SETTING,
  STAFF_SETTING,
  BREAKDOWN,
  BREAKDOWN_SETTINGS,
  BREAKDOWN_REPORT,
  TIME_WISE_MULTIDAY_REPORTS,
  DAY_MULTIDAY_REPORTS,
  PRODUCTION_COMPONENT,
  NOTIFICATION_SETTINGS,
  BREAKDOWN_ANALYSIS,
  PNL_SUMMARY_REPORTS,
  COMPANY_TEMPLATES,
} from "../constants/routes";

import get from "lodash/get"
import { Image, Tooltip } from "antd";
import logsIcon from "../static/icons/menu/logs.svg";
import leadsIcon from "../static/icons/menu/leads.svg";
import globeIcon from "../static/icons/menu/globe.svg";
import summaryIcon from "../static/icons/menu/summary.svg";
import reportIcon from "../static/icons/menu/report.svg";
import partIcon from "../static/icons/menu/part.svg";
import calendarIcon from "../static/icons/menu/calendar.svg";
import gridIcon from "../static/icons/menu/grid.svg";
import serverIcon from "../static/icons/menu/server.svg";
import settingIcon from "../static/icons/menu/setting.svg";
import clockIcon from "../static/icons/menu/clock.svg";
import operatorIcon from "../static/icons/menu/operator.svg";
import performanceIcon from "../static/icons/menu/performance.svg";
import partsIcon from "../static/icons/menu/parts.svg";
import breakdownIcon from "../static/icons/menu/fi_minus-square.svg";
import productionComponent from "../static/icons/menu/partitionOutlined.svg";
import broadCastIcon from "../static/icons/menu/Notificion.svg"
import antDesignAuditOutlined from "../static/icons/menu/AntDesignAuditOutlined.svg"
import pnlSummary from "../static/icons/menu/pnlsummary.svg"
import { iconstyle } from "../constants/stylesClasses";
import ImageContainer from "../components/ui/ImageContainer";
import { BREAKDOWN_PERMISSION, PNL_PERMISSION, NOTIFICATION_PERMISSION } from "../constants";

export const getAdminMenutems = (navigate, selectKey, roles, permissions = undefined) => {
  const { isSuperAdmin, isCompanyAdmin, isStaff } = roles;
  const pnlPermission = get(permissions, PNL_PERMISSION);
  const breakdownPermission = get(permissions, BREAKDOWN_PERMISSION);
  const notificationPermission = get(permissions, NOTIFICATION_PERMISSION)
  
  const staffSettingMenu = {
    key: STAFF_SETTING,
    icon: (
      <ImageContainer>
        <Image
          preview={false}
          src={antDesignAuditOutlined}
          alt="staff setting"
          className={`${selectKey === STAFF_SETTING && "white-color"
            } ${iconstyle}`}
        />
      </ImageContainer>
    ),
    label: (
      <Tooltip placement="right" title="Staff Settings">
        Staff
      </Tooltip>
    ),
  }

  const commanSetting = [
    {
      key: SHIFT_SETTING,
      icon: (
        <ImageContainer>
          <Image
            preview={false}
            src={calendarIcon}
            alt="shift setting"
            className={`${selectKey === SHIFT_SETTING && "white-color"
              } ${iconstyle}`}
          />
        </ImageContainer>
      ),
      label: (
        <Tooltip placement="right" title="Shift Settings">
          Shift Settings
        </Tooltip>
      ),
    },
    {
      key: PRODUCTION_COMPONENT,
      icon: (
        <ImageContainer>
          <Image
            preview={false}
            src={productionComponent}
            alt="production"
            className={`w-[1.5rem] h-[1.5rem] max-h-[1.5rem] max-w-[1.5rem] ${selectKey === PRODUCTION_COMPONENT
              ? "white-color"
              : "opacity-80"
              } ${iconstyle}`}
          />
        </ImageContainer>
      ),
      label: (
        <Tooltip placement="right" title="Production Component">
          Production Component
        </Tooltip>
      ),
      onClick: () => navigate(PRODUCTION_COMPONENT),
    },
    {
      key: PART_SETTING,
      icon: (
        <ImageContainer>
          <Image
            preview={false}
            src={partsIcon}
            alt="part setting"
            className={`${selectKey === PART_SETTING && "white-color"
              } ${iconstyle}`}
          />
        </ImageContainer>
      ),
      label: (
        <Tooltip placement="right" title="Parts Settings">
          Parts Settings
        </Tooltip>
      ),
    }
  ]

  if (!isStaff&&notificationPermission) {
    commanSetting.push({
      key: NOTIFICATION_SETTINGS,
      icon: (
        <ImageContainer>
          <Image
            preview={false}
            src={broadCastIcon}
            alt="notification"
            className={`${selectKey === NOTIFICATION_SETTINGS && "white-color"
              } ${iconstyle} maw-w-6 max-h-6`}
          />
        </ImageContainer>
      ),
      label: (
        <Tooltip placement="right" title="Parts Settings">
          Notification Settings
        </Tooltip>
      ),
    })
  }
 
  const staffMenuitem = [
    {
      key: DASHBOARD,
      icon: (
        <ImageContainer>
          <Image
            preview={false}
            src={gridIcon}
            alt="dashboard"
            className={`${selectKey === DASHBOARD && "white-color"
              } ${iconstyle}`}
          />
        </ImageContainer>
      ),
      label: "Dashboard",
      onClick: () => navigate(DASHBOARD),
    },
    {
      key: "SETTING",
      icon: (
        <ImageContainer>
          <Image
            preview={false}
            src={settingIcon}
            alt="setting"
            className={`${selectKey === SETTING && "white-color"} ${iconstyle}`}
          />
        </ImageContainer>
      ),
      label: "Settings",
      children: commanSetting,
    },
  ];

 const breakdownMenuChildren = [
    {
      key: BREAKDOWN_SETTINGS,
      icon: (
        <ImageContainer>
          <Image
            preview={false}
            src={settingIcon}
            alt={BREAKDOWN_SETTINGS}
            className={`${iconstyle} ${selectKey === BREAKDOWN_SETTINGS && "white-color"
              }`}
          />
        </ImageContainer>
      ),
      label: (
        <Tooltip placement="right" title="Breakdown settings">
          Breakdown Settings
        </Tooltip>
      ),
    }
  ];

  if (!isStaff && breakdownPermission) {
    breakdownMenuChildren.push(...[
      {
        key: BREAKDOWN_REPORT,
        icon: (
          <ImageContainer>
            <Image
              preview={false}
              src={summaryIcon}
              alt="summary"
              className={`
                ${selectKey === BREAKDOWN_REPORT && "white-color"
                } ${iconstyle}`}
            />
          </ImageContainer>
        ),
        label: (
          <Tooltip placement="right" title="Breakdown Report">
            Breakdown Report
          </Tooltip>
        ),
      },
      {
        key: BREAKDOWN_ANALYSIS,
        icon: (
          <ImageContainer>
            <Image
              preview={false}
              src={reportIcon}
              alt={BREAKDOWN_ANALYSIS}
              className={`${iconstyle} ${selectKey === BREAKDOWN_ANALYSIS && "white-color"
                }`}
            />
          </ImageContainer>
        ),
        label: (
          <Tooltip placement="right" title="Breakdown Analysis">
            Breakdown Analysis
          </Tooltip>
        ),
      },
    ])
  }

  if (breakdownPermission) {
    staffMenuitem.push({
      key: "BREAKDOWN",
      icon: (
        <ImageContainer>
          <Image
            preview={false}
            src={breakdownIcon}
            alt="breakdown"
            className={`${selectKey === BREAKDOWN && "white-color"
              } ${iconstyle}`}
          />
        </ImageContainer>
      ),
      label: "Breakdown",
      children: breakdownMenuChildren
    },)
  }

  const timeReportsChildren = [
    {
      key: TIME_WISE_GRAPH_REPORTS,
      icon: (
        <ImageContainer>
          <Image
            preview={false}
            src={reportIcon}
            alt="time reports"
            className={`${selectKey === TIME_WISE_GRAPH_REPORTS && "white-color"
              } ${iconstyle}`}
          />
        </ImageContainer>
      ),
      label: (
        <Tooltip placement="right" title="Time Wise Reports">
          Graph
        </Tooltip>
      ),
    },
    {
      key: TIME_WISE_SUMMARY_REPORTS,
      icon: (
        <ImageContainer>
          <Image
            preview={false}
            src={summaryIcon}
            alt="summary"
            className={`
                ${selectKey === TIME_WISE_SUMMARY_REPORTS && "white-color"
              } ${iconstyle}`}
          />
        </ImageContainer>
      ),
      label: (
        <Tooltip placement="right" title="Summary Reports">
          Summary
        </Tooltip>
      ),
    },
    {
      key: TIME_WISE_MULTIDAY_REPORTS,
      icon: (
        <ImageContainer>
          <Image
            preview={false}
            src={leadsIcon}
            alt="summary"
            className={`${selectKey === TIME_WISE_MULTIDAY_REPORTS && "white-color"
              } ${iconstyle}`}
          />
        </ImageContainer>
      ),
      label: (
        <Tooltip placement="right" title="Summary Reports">
          Day Detail Report
        </Tooltip>
      ),
    },
  ];

  if (pnlPermission) {
    timeReportsChildren.push({
      key: PNL_SUMMARY_REPORTS,
      icon: (
        <ImageContainer>
          <Image
            preview={false}
            src={pnlSummary}
            alt="pnl summary"
            className={`${selectKey === PNL_SUMMARY_REPORTS && "white-color"
              } ${iconstyle}`}
          />
        </ImageContainer>
      ),
      label: (
        <Tooltip placement="right" title="PNL Manager Wise Reports">
          PNL
        </Tooltip>
      ),
    })
  }

  if (isStaff) {
    return staffMenuitem;
  }
  const menutitems = [
    ...staffMenuitem,
    {
      key: "TIME_REPO",
      icon: (
        <ImageContainer>
          <Image
            preview={false}
            src={clockIcon}
            alt="personlisation"
            className={`${selectKey === REPORTS && "white-color"} ${iconstyle}`}
          />
        </ImageContainer>
      ),
      label: "Time Reports",
      children: timeReportsChildren,
    },
    {
      key: "DAY_REPO",
      icon: (
        <ImageContainer>
          <Image
            preview={false}
            src={calendarIcon}
            alt="personlisation"
            className={`${selectKey === REPORTS && "white-color"} ${iconstyle}`}
          />
        </ImageContainer>
      ),
      label: "Day Reports",
      children: [
        {
          key: DAY_GRAPH_REPORT,
          icon: (
            <ImageContainer>
              <Image
                preview={false}
                src={reportIcon}
                alt="day graph"
                className={`${selectKey === DAY_GRAPH_REPORT && "white-color"
                  } ${iconstyle}`}
              />
            </ImageContainer>
          ),
          label: (
            <Tooltip placement="right" title="Day Wise Reportss">
              Graph
            </Tooltip>
          ),
        },
        {
          key: DAY_SUMMARY_REPORT,
          icon: (
            <ImageContainer>
              <Image
                preview={false}
                src={summaryIcon}
                alt="day summary"
                className={`${selectKey === DAY_SUMMARY_REPORT && "white-color"
                  } ${iconstyle}`}
              />
            </ImageContainer>
          ),
          label: (
            <Tooltip placement="right" title="Day Wise Reportss">
              Summary
            </Tooltip>
          ),
        },
        {
          key: DAY_MULTIDAY_REPORTS,
          icon: (
            <ImageContainer>
              <Image
                preview={false}
                src={leadsIcon}
                alt="summary"
                className={`${selectKey === DAY_MULTIDAY_REPORTS && "white-color"
                  } ${iconstyle}`}
              />
            </ImageContainer>
          ),
          label: (
            <Tooltip placement="right" title="Day Wise Reportss">
              Multi-Day Report
            </Tooltip>
          ),
        },
      ],
    },
    {
      key: "OPERATOR_REPO",
      icon: (
        <ImageContainer>
          <Image
            preview={false}
            src={operatorIcon}
            alt="personlisation"
            className={`${selectKey === REPORTS && "white-color"} ${iconstyle}`}
          />
        </ImageContainer>
      ),
      label: "Operator Reports",
      children: [
        {
          key: OPERATOR_SUMMARY_REPORT,
          icon: (
            <ImageContainer>
              <Image
                preview={false}
                src={logsIcon}
                alt="operator summary"
                className={`${selectKey === OPERATOR_SUMMARY_REPORT && "white-color"
                  } ${iconstyle}`}
              />
            </ImageContainer>
          ),
          label: (
            <Tooltip placement="right" title="Time Wise Reports">
              Summary
            </Tooltip>
          ),
        },
        {
          key: OPERATOR_DETAIL_REPORT,
          icon: (
            <ImageContainer>
              <Image
                preview={false}
                src={leadsIcon}
                alt="summary"
                className={`${selectKey === OPERATOR_DETAIL_REPORT && "white-color"
                  } ${iconstyle}`}
              />
            </ImageContainer>
          ),
          label: (
            <Tooltip placement="right" title="Summary Reports">
              Detail
            </Tooltip>
          ),
        },
      ],
    },
    {
      key: "PART_REPO",
      icon: (
        <ImageContainer>
          <Image
            preview={false}
            src={partIcon}
            alt="personlisation"
            className={`${selectKey === REPORTS && "white-color"} ${iconstyle}`}
          />
        </ImageContainer>
      ),
      label: "Part Reports",
      children: [
        {
          key: PART_SUMMARY_REPORT,
          icon: (
            <ImageContainer>
              <Image
                preview={false}
                src={logsIcon}
                alt="part summary"
                className={`${selectKey === PART_SUMMARY_REPORT && "white-color"
                  } ${iconstyle}`}
              />
            </ImageContainer>
          ),
          label: (
            <Tooltip placement="right" title="Time Wise Reports">
              Summary
            </Tooltip>
          ),
        },
        {
          key: PART_DETAIL_REPORT,
          icon: (
            <ImageContainer>
              <Image
                preview={false}
                src={leadsIcon}
                alt="summary"
                className={`${selectKey === PART_DETAIL_REPORT && "white-color"
                  } ${iconstyle}`}
              />
            </ImageContainer>
          ),
          label: (
            <Tooltip placement="right" title="Summary Reports">
              Detail
            </Tooltip>
          ),
        },
      ],
    },
    {
      key: PERFORMANCE_REPORT,
      icon: (
        <ImageContainer>
          <Image
            preview={false}
            src={performanceIcon}
            alt="personlisation"
            className={`${selectKey === PERFORMANCE_REPORT && "white-color"
              } ${iconstyle}`}
          />
        </ImageContainer>
      ),
      label: "Performance Report",
      onClick: () => navigate(PERFORMANCE_REPORT),
    },
  ];

  if (isSuperAdmin) {
    menutitems.splice(1, 0, {
      key: COMPANY_SETTINGS,
      icon: (
        <ImageContainer>
          <Image
            preview={false}
            src={globeIcon}
            alt="company settings"
            className={`${selectKey === COMPANY_SETTINGS && "white-color"
              } ${iconstyle}`}
          />
        </ImageContainer>
      ),
      label: (
        <Tooltip placement="right" title="Company">
          Company
        </Tooltip>
      ),
    });
    menutitems.splice(2, 0, {
      key: TEMPLATES,
      icon: (
        <ImageContainer>
          <Image
            preview={false}
            src={serverIcon}
            alt="personlisation"
            className={`${selectKey === TEMPLATES && "white-color"
              } ${iconstyle}`}
          />
        </ImageContainer>
      ),
      label: (
        <Tooltip placement="right" title="Template">
          Templates
        </Tooltip>
      ),
      onClick: () => navigate(TEMPLATES),
    });
  }
  if(isCompanyAdmin){
     menutitems.splice(2, 0, {
      key: COMPANY_TEMPLATES,
      icon: (
        <ImageContainer>
          <Image
            preview={false}
            src={serverIcon}
            alt="company_template"
            className={`${selectKey === COMPANY_TEMPLATES && "white-color"
              } ${iconstyle}`}
          />
        </ImageContainer>
      ),
      label: (
        <Tooltip placement="right" title="Template">
          Templates
        </Tooltip>
      ),
      onClick: () => navigate(COMPANY_TEMPLATES),
    });
  }
  if (isSuperAdmin) {
    menutitems.splice(3, 0, staffSettingMenu)
  }
  if (isCompanyAdmin) {
    menutitems.splice(1, 0, staffSettingMenu)
  }
  return menutitems;
};

export const getMenuItems = (onClickLogout) => [
  {
    key: "2",
    label: "Logout",
    onClick: () => onClickLogout(),
  },
];
